import SaSwitchIcons from "../saSwitchIcons/saSwitchIcons"
import { SaTitle } from "../saTitle/saTitle"
import * as React from "react"
import { saTypeBoxesItem } from "../saTypes"

// @ts-ignore
import {  saItem,  saItemBlock,  saItemIcon,  saItemText,  saItemTitle,  saItemTitleContainer } from "./saListIconsWithText.module.scss"


export const SaListIconsWithText: React.FC<Array<saTypeBoxesItem>> = ( {...props} ):any => {


  if (!props) return null

  return Object.values(props).map((item, index) => (
      <div key={index} className={saItem}>
        <div className={saItemIcon}>
          <SaSwitchIcons icon={item.icon} />
        </div>
        <div className={saItemBlock}>
          <div className={saItemTitleContainer}>
            <SaTitle title={item.title} classes={saItemTitle} />
          </div>
          <div className={saItemText}
               dangerouslySetInnerHTML={{ __html: item.text }} />
        </div>
      </div>
    )
  )
}